import { RouteLocationNormalized } from 'vue-router'

import { AppStateEnum } from '@/enums'
import { GlobalState } from '@/store/modules/global/state'

import { GlobalMutationTypes } from './mutation_types'

export const mutations = {
  [GlobalMutationTypes.SET_APP_STATE](state: GlobalState, value: AppStateEnum) {
    state.appState = value
  },
  [GlobalMutationTypes.SET_IS_PENDO_LOADED](state: GlobalState, value: boolean) {
    state.isPendoLoaded = value
  },
  [GlobalMutationTypes.SET_MINI](state: GlobalState, value: boolean) {
    state.mini = value
  },
  [GlobalMutationTypes.SET_HOME_LAYOUT](state: GlobalState, value: boolean) {
    state.homeLayout = value
  },
  [GlobalMutationTypes.SET_PROJECT_LAYOUT](state: GlobalState, value: boolean) {
    state.projectLayout = value
  },
  [GlobalMutationTypes.SET_TOGGLE_PROJECT_DRAWER](state: GlobalState, value: boolean) {
    state.toggleProjectDrawer = value
  },
  [GlobalMutationTypes.SET_NAVIGATION_DRAWER_PROFILE](state: GlobalState, value: boolean) {
    state.navigationDrawerProfile = value
  },
  [GlobalMutationTypes.SET_BADGE_PROFILE_VISIBLE](state: GlobalState, value: boolean) {
    state.badgeProfileVisible = value
  },
  [GlobalMutationTypes.SET_ROUTER_HISTORY](state: GlobalState, value: RouteLocationNormalized) {
    state.routerHistory.push(value)
  },
}
